import axiosClient from "../../../../../../axiosClient"

export default async (preCheckId) => {
    const result = await axiosClient.get(`/pre-check-client-decision/${preCheckId}`)
    return result.data
}
